var React = require('react');

function TickCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.46266 11.8289L8.81621 12.1824L9.16976 11.8289L13.4531 7.54555C13.4746 7.52402 13.5054 7.51074 13.5412 7.51074C13.5771 7.51074 13.6078 7.52402 13.6293 7.54555C13.6509 7.56707 13.6641 7.59781 13.6641 7.63366C13.6641 7.66951 13.6509 7.70024 13.6293 7.72177L8.90432 12.4468C8.88035 12.4707 8.84876 12.4837 8.81621 12.4837C8.78366 12.4837 8.75207 12.4707 8.7281 12.4468L6.36976 10.0884C6.34824 10.0669 6.33496 10.0362 6.33496 10.0003C6.33496 9.96447 6.34824 9.93374 6.36976 9.91221C6.39129 9.89069 6.42203 9.87741 6.45788 9.87741C6.49373 9.87741 6.52446 9.89069 6.54599 9.91221L8.46266 11.8289Z","fill":"#212529","stroke":"#CCCCCC"}));
}

TickCircle.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = TickCircle;

TickCircle.default = TickCircle;
